export const OpeningHours = {
    Phone: "09.00-15.00",
    Chat: {
        MonFri: "09.00-21.00",
        SunSat: "09.00-16.00"
    }
}

export const PhoneNumbers = {
    Default: "88772000",
    Contact: {
        Desktop: "70604552",
        Mobile: "30202580",
    },
    Raffle: "70604687",
}
